module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_002.png
// module id = 925
// module chunks = 0